<fuse-app-lessons-tab
    class="page-layout simple inner-scroll"
    fxFlex
    type="currentUser"
    [hiddenForcedFilters]="forceFilters"
    [urlFilters]="filters"
></fuse-app-lessons-tab>
